export type ColorMode = 'light' | 'dark';

export const COLOR_MODE_STORAGE_KEY = 'deepco-color-mode';

export const DEFAULT_COLOR_MODE: ColorMode = 'dark';

export function getStoredColorMode(): ColorMode {
  if (typeof window === 'undefined') return DEFAULT_COLOR_MODE;
  const stored = window.localStorage.getItem(COLOR_MODE_STORAGE_KEY);
  return stored === 'light' || stored === 'dark' ? stored : DEFAULT_COLOR_MODE;
}

export function applyColorMode(mode: ColorMode): void {
  document.documentElement.setAttribute('data-theme', mode);
  document.documentElement.style.colorScheme = mode;
}
